import { useNavigate } from "react-router-dom";
import { useLabBooking } from "../context/LabBookingContext";

const StickyCartBar = ({ className = "" }) => {
  const { selectedTests } = useLabBooking();
  const navigate = useNavigate();

  if (selectedTests.length === 0) return null;

  return (
    <div
      className={`mt-4 bg-[#0F3D3A] rounded-2xl px-5 py-3.5 flex items-center justify-between ${className}`}
    >
      <span className="text-white text-[13px] font-semibold">
        {selectedTests.length} test{selectedTests.length > 1 ? "s" : ""} added
      </span>
      <button
        onClick={() => navigate("/lab-booking/compare")}
        className="text-white text-[13px] font-semibold flex items-center gap-1"
      >
        Compare Labs →
      </button>
    </div>
  );
};

export default StickyCartBar;
